// export const API = "http://localhost:8000/";
// export const API = "https://prod.ehsprints.com:8000/"; //for checking
export const API1 = 'https://dev.ehsprints.com:4000/';
//  export const API = "http://localhost:8000/"; 

// export const API1 = 'http://localhost:4000/'; 
export const API = 'https://dev.ehsprints.com:8000/';  // for production this link will be used now
// console.log(API);
